import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { LoginResponse } from '../../../../shared/auth/models/login-response';

@Injectable({
  providedIn: 'root'
})
export class AuthApiService extends ApiService {

  constructor(http: HttpClient) {
    super(http);
  }

  public cadastro(login: string, email: string, senha: string): Observable<void> {
    return this.post<void>('/auth/cadastro', null, { login, email, senha });
  }

  public esqueciSenha(login: string): Observable<void> {
    return this.post<void>('/auth/esqueci-senha', null, { login });
  }
}
